import { Routes } from '@angular/router';
import { authGuard } from './core/auth-guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then((m) => m.Login),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/forgot-password/forgot-password').then((m) => m.ForgotPassword),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./pages/reset-password/reset-password').then((m) => m.ResetPassword),
  },
  {
    // Pública: la abre el dueño de una casilla desde el link del correo, sin sesión en el panel.
    path: 'confirmar-casilla',
    loadComponent: () =>
      import('./pages/confirm-mailbox/confirm-mailbox').then((m) => m.ConfirmMailbox),
  },
  {
    path: '',
    loadComponent: () => import('./layout/shell/shell').then((m) => m.Shell),
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'logs',
        loadComponent: () => import('./pages/logs/logs').then((m) => m.Logs),
      },
      {
        path: 'conversations',
        loadComponent: () =>
          import('./pages/conversations/conversations').then((m) => m.Conversations),
      },
      {
        path: 'unattributed',
        loadComponent: () =>
          import('./pages/unattributed/unattributed').then((m) => m.Unattributed),
      },
      {
        path: 'bots',
        loadComponent: () => import('./pages/bots/bots').then((m) => m.Bots),
      },
      {
        // Editor de un flujo: lienzo con nodos que se arrastran y conectan.
        path: 'bots/:id',
        loadComponent: () => import('./pages/bots/bot-editor').then((m) => m.BotEditor),
      },
      {
        path: 'emails',
        loadComponent: () => import('./pages/emails/emails').then((m) => m.Emails),
      },
      {
        path: 'mailboxes',
        loadComponent: () => import('./pages/mailboxes/mailboxes').then((m) => m.Mailboxes),
      },
      {
        path: 'webhooks',
        loadComponent: () => import('./pages/webhooks/webhooks').then((m) => m.Webhooks),
      },
      {
        path: 'consents',
        loadComponent: () => import('./pages/consents/consents').then((m) => m.Consents),
      },
      {
        path: 'costs',
        loadComponent: () => import('./pages/costs/costs').then((m) => m.Costs),
      },
      {
        path: 'batches',
        loadComponent: () => import('./pages/batches/batches').then((m) => m.Batches),
      },
      {
        path: 'campaigns',
        loadComponent: () => import('./pages/campaigns/campaigns').then((m) => m.Campaigns),
      },
      {
        path: 'templates',
        loadComponent: () => import('./pages/templates/templates').then((m) => m.Templates),
      },
      {
        path: 'providers',
        loadComponent: () => import('./pages/providers/providers').then((m) => m.Providers),
      },
      {
        path: 'system',
        loadComponent: () => import('./pages/system/system').then((m) => m.System),
      },
      {
        path: 'applications',
        loadComponent: () =>
          import('./pages/applications/applications').then((m) => m.Applications),
      },
      {
        path: 'numbers',
        loadComponent: () => import('./pages/numbers/numbers').then((m) => m.Numbers),
      },
      {
        path: 'audit',
        loadComponent: () => import('./pages/audit/audit').then((m) => m.Audit),
      },
      {
        path: 'http-logs',
        loadComponent: () => import('./pages/http-logs/http-logs').then((m) => m.HttpLogs),
      },
      {
        path: 'admins',
        loadComponent: () => import('./pages/admins/admins').then((m) => m.Admins),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
